<template>
  <div class="circleHeight">
    <van-row type="flex" justify="space-between" class="circleTitle">
      <van-col span="10" class="nameTitle">{{cardData.name}}</van-col>
      <van-col span="14" class="buttonChange timeButton">
        <button :class="{ choose:1===time }" @click="changeTime(1)" v-if="showFlag.indexDay">日</button>
        <button :class="{ choose:2===time }" @click="changeTime(2)" v-if="showFlag.indexMonth">月</button>
        <button :class="{ choose:3===time }" @click="changeTime(3)" v-if="showFlag.indexYear">年</button>
        <p class="tiem-iconfont"  @click="showPopup">
          <img src="../../../../static/images/calendar.png" style="width:.21rem;height:.2rem">
        </p>
      </van-col>
    </van-row>
    <van-row type="flex" class="circle" v-if="cardData.classification!==5">
        <van-col span="12">
          <!-- 判断返回值是null 显示-- -->
          <p v-if="cardData.indexValue === '--'">
            <span>{{cardData.indexValue}}</span>{{cardData.unit}}
          </p>
          <p v-else>
            <span>{{cardData.indexValue}}</span>{{cardData.unit}}
            <!-- <span>{{cardData.indexValue | changeMoneyFilter}}</span>{{cardData.indexValue | changeUnitFilter}}{{cardData.unit}} -->
          </p>
        </van-col>
        <van-col class="ratevalue-warpper" span="6" v-show="time===3">
          <div class="ratevalue-value-second" v-if="showFlag.hasAchievementRate">
            <!-- <img src="../../../../static/images/splitLine.png"> -->
          </div>
          <div class="ratevalue-value" v-if="showFlag.hasAchievementRate">
            <span>{{cardData.achievementRate}}{{cardData.achievementRateUnit}}</span>
            <p>{{cardData.achievementRateName}}</p>
          </div>
        </van-col>
        <van-col class="ratevalue-warpper" span="6" v-show="time===3">
          <div class="ratevalue-value-second" v-if="showFlag.hasAchievementRate">
            <!-- <img src="../../../../static/images/splitLine.png"> -->
          </div>
          <div class="ratevalue-value">
            <span>{{cardData.onYearRate}}{{cardData.onYearRateUnit}}</span>
            <p>年同比</p>
          </div>
        </van-col>
    </van-row>
    <van-row type="flex" class="circle" justify="center" v-else>
      <van-col span="16">
        <p style="text-align:center">
          {{cardData.achievementRateName}}<span>{{cardData.achievementRate}}</span>{{cardData.unit}}
        </p>
      </van-col>
    </van-row>
    <van-row type="flex" class="circleFooter">
      <van-col span="6">{{cardData.orgName}}</van-col>
      <van-col span="18" :style="{textAlign:'right'}">统计时间：{{cardData.yearTime}}</van-col>
    </van-row>
    <van-popup v-model="show"
    position="bottom"
    :style="{ height: '40%' }">
      <van-datetime-picker
        ref="picker"
        v-model="currentDate"
        :type="showTime"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="cancel"
        @confirm="confirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { postAction, getAction } from '@/utils/api'
import { getCurrentMonthLast, getCurrentTime, minTime, maxTime, getUrlKey } from '@/utils/util'
import Bus from '@/utils/bus'
export default {
  name: 'Record',
  data () {
    return {
      date: '',
      time: 2,
      daydate: '',
      show: false,
      cardData: {name: '--', indexValue: '--', orgName: '--'},
      showTime: 'year-month',
      minDate: '',
      maxDate: '',
      currentDate: new Date(),
      getUrl: '', //  获取url的indexId
      getUrl1: '', //  获取url的businessId
      getOrgId: '', //  获取url的orgId
      getLevel: '', //  获取url的level
      getCode: '',
      getPathId: '',
      getCareDesc: '',
      showFlag: {},
      passTime: '',
      passTimeDate: '',
      // careDesc: '', //  关注的描述
      // pathId: ''//  关注调整条件,
      range: [
      ]
    }
  },
  methods: {
    getDate () {
      let { picker } = this.$refs
      return new Date(
        Array.from(
          picker.$el.querySelectorAll('.van-picker-column__item--selected')
        ).map(_ => {
          return parseInt(_.textContent)
        }).join('/')
      )
    },
    // 通过传入filter函数，可以对选项数组进行过滤，实现自定义时间间隔
    filter (type, options) {
      if (this.range.length < 1) return []
      let currentDate = new Date(this.currentDate)
      let currentYear = currentDate.getFullYear()
      let currentMonth = currentDate.getMonth() + 1
      let item = this.range.find(_ => +_.year === currentYear)
      let startTime = new Date(item.startTime)
      let endTime = new Date(item.endTime)
      let months = [startTime.getMonth() + 1, endTime.getMonth() + 1]
      let days = [startTime.getDate(), endTime.getDate()]
      if (type === 'year') {
        return this.range.map(_ => _.year)
      } else if (type === 'month') {
        return options.filter(_ => {
          return +_ >= months[0] && +_ <= months[1]
        })
      } else if (type === 'day') {
        if (months[0] === months[1]) {
          return Array.apply(null, { length: 31 }).map((_, i) => {
            i += 1
            return i < 10 ? '0' + i : i + ''
          }).filter(_ => +_ >= days[0] && +_ <= days[1])
          // return options.filter(_ => +_ >= days[0] && +_ <= days[1])
        }
        if (currentMonth === months[0]) {
          return options.filter(_ => +_ >= days[0])
        } else if (currentMonth === months[1]) {
          return options.filter(_ => +_ <= days[1])
        }
        return options
      }
    },
    // 通过传入formatter函数，可以对选项文字进行格式化处理 value为时间戳
    formatter (type, value) {
      if (type === 'year') {
        return `${value}`
      } else if (type === 'month') {
        return `${value}`
      }
      return value
    },
    // 增加导航头
    getHeaderInfo (val) {
      var postData
      var url = '/simpapp/menu/menuIndexApi'
      this.getUrl = getUrlKey('indexId', window.location.href)
      this.getUrl1 = getUrlKey('businessId', window.location.href)
      if (this.getUrl && this.getUrl1) {
        postData = {
          'indexCode': this.getUrl,
          'pageCode': this.getUrl1,
          'date': this.date || '',
          'dateType': this.time
        }
      } else {
        postData = {
          'indexCode': this.$store.state.entirety.quota,
          'pageCode': this.$store.state.entirety.kind,
          'date': this.date || '',
          'dateType': this.time
        }
      }
      var obj = postAction(url, postData)
      let self = this
      obj.then(res => {
        self.channelData = res.data.salechnl
        let dataSalechnlCode = []
        if (val === 0) {
          let tmpChannel = self.$store.state.entirety.channel
          self.channelData.forEach(item => {
            dataSalechnlCode.push(item.dataSalechnlCode)
          })
          if (dataSalechnlCode.indexOf(tmpChannel) === -1) {
            self.$store.commit('ENTIRETY_SET_CHANNEL', res.data.salechnl[0].dataSalechnlCode)
          }
          // 判断接口返回数据个险或者大个险指标channelID
          if (tmpChannel === '0200' || tmpChannel === '0201') {
          // 如果上次选中的是0200 或 0201 个险重新保存 ENTIRETY_SET_CHANNEL
            self.$store.commit('ENTIRETY_SET_CHANNEL', res.data.salechnl[1].dataSalechnlCode)
            self.$store.commit('ENTIRETY_SET_CHANNEL_NAME', res.data.salechnl[1].salechnlName)
          }
        } else {
          // 首次进入
          self.$store.commit('ENTIRETY_SET_CHANNEL', self.channelData[0].dataSalechnlCode)
          self.$store.commit('ENTIRETY_SET_CHANNEL_NAME', self.channelData[0].salechnlName)
        }
        // 获取当前channelData全部内容并存储传值
        console.log('操作后 : ', self.$store.state.entirety.channel)
        Bus.$emit('channelData', self.channelData)
      })
    },
    getHomeInfo () {
      var getPostdata = {
        moduleId: this.$store.state.user.pageCode,
        indexId: this.$store.state.entirety.quota,
        channelId: this.$store.state.entirety.channel,
        date: this.date || ''
      }
      var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
      getFlag.then(res => {
        this.showFlag = res.data
        this.getCardContent()
      })
    },
    getCardContent () {
      if (this.showFlag.indexMonth === 0 && this.showFlag.indexYear === 1) {
        this.time = 3
        this.$store.commit('ENTIRETY_SET_TIME', this.time)
        this.$store.commit('ENTIRETY_SET_TIME_NAME', '年')
      }
      var url = ''
      if (this.$store.state.user.pageCode === '02') {
        url = this.$store.state.user.areaFlag === '1' ? '/simpapp/performance/getYeJiAreaIndexCard' : '/simpapp/performance/getYeJiIndexCard'
      } else {
        url = '/simpapp/performance/getYeJiIndexCard'
      }
      var postData = {
        'channelId': this.$store.state.entirety.channel,
        'classification': this.$store.state.entirety.kind,
        'date': this.date || '',
        'dateType': this.time,
        'indexId': new Array(this.$store.state.entirety.quota),
        'level': this.$store.state.user.level,
        'orgId': this.$store.state.user.orgId
      }
      var obj = postAction(url, postData)
      obj.then(res => {
        if (res.code !== 0) {
          return ''
        } else {
          this.cardData = res.data
          this.$emit('year', this.cardData.yearTime.substr(0, 4))
          this.passTime = res.data.yearTime
          //  获取后重新传值
          this.$store.commit('ENTIRETY_SET_QUOTA', this.cardData.indexId)
          this.$store.commit('ENTIRETY_SET_QUOTA_NAME', this.cardData.name)
          localStorage.setItem('quotaname', this.cardData.name)
          // document.title = localStorage.getItem('quotaname')
          if (this.cardData.achievementRate === null) {
            this.cardData.achievementRate = '--'
          }
          if (this.cardData.onYearRate === null) {
            this.cardData.onYearRate = '--'
          }
          // 判断显示为null 渲染--
          if (this.cardData.indexValue === null) {
            this.cardData.indexValue = '--'
          }
        }
      })
    },
    changeTime (index) {
      this.time = index
      // this.date = ''
      this.$emit('postDate', this.date, this.currentDate)
      this.$emit('year', this.date.substr(0, 4))
      this.$store.commit('ENTIRETY_SET_TIME', index)
      if (index === 1) {
        this.$store.commit('ENTIRETY_SET_TIME_NAME', '日')
      } else if (index === 2) {
        this.$store.commit('ENTIRETY_SET_TIME_NAME', '月')
        if (this.$store.state.user.pageCode === '03' && (this.$store.state.entirety.quota === 'A0202-1005' || this.$store.state.entirety.quota === 'A0201-1004')) {
          this.date = this.date.substring(0, 6)
          this.$emit('postDate', this.date, this.currentDate)
          this.$emit('year', this.date.substr(0, 4))
        }
        // 对于特殊指标合格人力日月年切换进行特殊处理，切换日月年，历史时间只传（年月）
        if (this.$store.state.user.pageCode === '02' && this.$store.state.entirety.quota === 'A0202-1013') {
          this.date = this.date.substring(0, 6)
          this.$emit('postDate', this.date, this.currentDate)
          this.$emit('year', this.date.substr(0, 4))
        }
      } else {
        this.$store.commit('ENTIRETY_SET_TIME_NAME', '年')
        // 对于特殊指标合格人力日月年切换进行特殊处理，切换日月年，历史时间只传（年月）
        if (this.$store.state.user.pageCode === '02' && this.$store.state.entirety.quota === 'A0202-1013') {
          this.date = this.date.substring(0, 6)
          this.$emit('postDate', this.date, this.currentDate)
          this.$emit('year', this.date.substr(0, 4))
        }
      }
      this.currentDate = new Date()
      this.getHomeInfo()
    },
    showPopup () {
      var timePost = {
        'dateType': this.time,
        'indexId': new Array(this.$store.state.entirety.quota),
        'channelId': this.$store.state.entirety.channel,
        'classification': this.$store.state.entirety.kind
      }
      this.showFlag.path = '/performance/controlTime/getTime'
      var timeObj = postAction(this.showFlag.path, timePost)
      timeObj.then(res => {
        // /simpapp/controlTime/preGetTime 预录入接口
        if (this.showFlag.path === '/performance/controlTime/preGetTime') {
          res.data.sort((a, b) => {
            return +a.year > +b.year ? 1 : -1
          })
          this.range = res.data
          this.show = true
          return false
        }
        var timeStart = res.data.startDate.split('')
        if (timeStart.length < 8) {
          timeStart.splice(4, 0, '/')
          this.minDate = new Date(timeStart.join('').concat('/01'))
        } else {
          timeStart.splice(4, 0, '/')
          if (timeStart.length > 7) {
            timeStart.splice(7, 0, '/')
          }
          this.minDate = new Date(timeStart.join(''))
        }
        if (res.data.endDate) {
          var timeEnd = res.data.endDate.split('')
          timeEnd.splice(4, 0, '/')
          if (timeEnd.length > 7) {
            timeEnd.splice(7, 0, '/')
            this.maxDate = new Date(timeEnd.join(''))
          } else {
            this.maxDate = new Date(timeEnd.join('').concat('/01'))
          }
        } else {
          this.maxDate = new Date()
        }
        // 修改日历精度展示类型
        if (this.$store.state.entirety.quota === 'A0202-1013') {
          if (this.time === 1) {
            this.showTime = 'date'
          } else {
            this.showTime = 'year-month'
          }
        } else {
          if (this.showFlag.timeAccuracy === '1') {
            this.showTime = 'date'
          } else {
            this.showTime = 'year-month'
          }
        }
        // if (this.$store.state.user.pageCode === '04') {
        //   if ((this.time === 1 || this.time === 2 || this.time === 3) && (this.showFlag.indexCode === 'A0104-1002' || this.showFlag.indexCode === 'A0104-1003' || this.showFlag.indexCode === 'T-A0104-1002' || this.showFlag.indexCode === 'A0104-1055')) {
        //     this.showTime = 'date'
        //   } else {
        //     this.showTime = 'year-month'
        //   }
        // } else if (this.$store.state.user.pageCode === '05') {
        //   if ((this.time === 1 || this.time === 2 || this.time === 3) && this.showFlag.indexCode === 'T-A0101-1002') {
        //     this.showTime = 'date'
        //   } else {
        //     this.showTime = 'year-month'
        //   }
        // } else if (this.$store.state.user.pageCode === '02') {
        //     // timeAccuracy指标表示日历范围展示的精确度(1为年月日，0为年月)
        //   if ((this.time === 1 || this.time === 2 || this.time === 3) && this.showFlag.timeAccuracy === '1') {
        //     this.showTime = 'date'
        //   } else {
        //     this.showTime = 'year-month'
        //     // 如果满足日期为日并且是合格人力指标和期末规模人力，展示时间段为年月日，否则展示年月
        //     if (this.time === 1 && this.showFlag.timeAccuracy === '0') {
        //       this.showTime = 'date'
        //     } else {
        //       this.showTime = 'year-month'
        //     }
        //   }
        // } else {
        //   if (this.time === 1 || this.time === 2 || this.time === 3) {
        //     this.showTime = 'date'
        //   } else {
        //     this.showTime = 'year-month'
        //     if (this.$store.state.user.pageCode === '03' && this.time === 1 && this.showFlag.timeAccuracy === '0') {
        //       this.showTime = 'date'
        //     } else {
        //       this.showTime = 'year-month'
        //     }
        //   }
        // }
        this.show = true
      })
    },
    cancel () {
      this.show = false
    },
    confirm (date) {
      this.currentDate = date
      var curTime
      this.show = false
      if (this.$store.state.entirety.quota === 'A0202-1013') {
        curTime = getCurrentTime(new Date())
        if (this.time === 1) {
          if (getCurrentTime(this.currentDate) === curTime) {
            this.date = getCurrentTime(new Date(this.currentDate.getTime() - 24 * 60 * 60 * 1000))
          } else {
            this.date = getCurrentTime(this.currentDate)
          }
        } else {
           this.date = getCurrentTime(this.currentDate).substring(0, 6)
        }
        this.$emit('postDate', this.date, this.currentDate)
        this.$emit('year', this.date.substr(0, 4))
      } else {
        if (this.showFlag.timeAccuracy === '1') {
        curTime = getCurrentTime(new Date())
        if (getCurrentTime(this.currentDate) === curTime) {
          this.date = ''
        } else {
          this.date = getCurrentTime(this.currentDate)
        }
        this.$emit('postDate', this.date, this.currentDate)
        this.$emit('year', this.date.substr(0, 4))
      } else {
        curTime = new Date(new Date().getFullYear(), new Date().getMonth())
        if (this.currentDate < curTime) {
          this.date = getCurrentMonthLast(this.currentDate)
        } else {
          this.date = ''
        }
        this.$emit('postDate', this.date, this.currentDate)
        this.$emit('year', this.date.substr(0, 4))
      }
      }
      // 点击日历确定按钮 刷新导航头
      // this.getHeaderInfo(0)
      this.getHomeInfo()
    }
  },
  computed: {
    getChannel () {
      return this.$store.state.entirety.channel
    }
  },
  watch: {
    passTime (newvalue, oldvalue) { // 监听所选日期
      this.passTimeDate = newvalue
      this.passCurrentDate = this.currentDate
      localStorage.setItem('passTimeDate', this.passTimeDate) // 年月日日期
      localStorage.setItem('passCurrentDate', this.passCurrentDate) // 组件日期
    },
    getChannel () {
      this.$nextTick(() => {
        if (this.$store.state.entirety.channel) {
          this.getHomeInfo()
        }
      })
    },
    date () {
      this.$nextTick(() => {
        this.$store.commit('ENTIRETY_SET_CALENDAR', this.date)
      })
    }
  },
  mounted () {
    if (this.$store.state.entirety.quota === 'A0201-1002' && (this.$store.state.user.pageCode === '03' || this.$store.state.user.pageCode === '02')) {
      this.time = 3
    }
    // 在此处接收后台返回的数据用this.dateRange
    // this.dateRange = 后台返回值
    //  从Android和iOS获取的url截取参数
    // this.getCode = getUrlKey('pageCode', window.location.href)
    // this.getUrl = getUrlKey('indexId', window.location.href)
    // this.getUrl1 = getUrlKey('businessId', window.location.href)
    // this.getOrgId = getUrlKey('orgId', window.location.href)
    // this.getLevel = getUrlKey('level', window.location.href)
    // this.getPathId = getUrlKey('pathId', window.location.href)
    // this.getCareDesc = getUrlKey('careDesc', window.location.href)
    // this.getCareTitle = getUrlKey('careTitle', window.location.href)
    // if (this.getUrl && this.getUrl1) {
    //   //  重新在vuex中管理参数
    //   this.$store.commit('USER_SET_PAGE_CODE', this.getCode)
    //   this.$store.commit('USER_SET_ORG', this.getOrgId)
    //   this.$store.commit('USER_SET_LEVEL', this.getLevel)
    //   this.$store.commit('ENTIRETY_SET_KIND', this.getUrl1)
    //   this.$store.commit('ENTIRETY_SET_QUOTA', this.getUrl)
    //   this.$store.commit('ENTIRETY_SET_CAREDESC', this.getCareDesc)
    //   this.$store.commit('ENTIRETY_SET_TITLE', this.getCareTitle)
    //   this.$store.commit('ENTIRETY_SET_PATHID', this.getPathId)
    //   localStorage.setItem('getPath', this.getPathId)
    //   localStorage.setItem('getDesc', this.getCareDesc)
    //   localStorage.setItem('getTitle', this.getCareTitle)
    // }
    this.getCode = this.$store.state.user.pageCode
    this.minDate = minTime()
    this.maxDate = maxTime()
    this.date = ''
    this.currentDate = new Date()
    this.$emit('postDate', this.date, this.currentDate)
    this.$emit('year', this.date.substr(0, 4))
    this.$store.commit('ENTIRETY_SET_CALENDAR', this.date)
    this.$store.commit('ENTIRETY_SET_TIME', 2)
    this.$store.commit('ENTIRETY_SET_TIME_NAME', '月')
    if (this.$store.state.entirety.channel) {
      // this.getHeaderInfo()
      if (this.getCode === '03' || this.getCode === '02 ' || this.getCode === '05' || this.getCode === '04') {
        this.time = this.$store.state.entirety.time
      }
      this.getHomeInfo()
    } else if (this.getCode === '04') {
      if (this.$store.state.entirety.quota === 'A0104-1004') {
        this.$store.commit('ENTIRETY__SET_CHANNEL', '0401')
        this.getHomeInfo()
      }
    }
    if (this.getCode === '03' || this.getCode === '02 ' || this.getCode === '05') {
      this.$store.commit('ENTIRETY_SET_TIME', this.time)
    }
  }
}
</script>

<style lang="stylus" scoped>
.van-popup--center{
  width : 100%;
}
.circle p{
  color: #333;
  font-size: 0.12rem;
  line-height: 0.3rem;
  // padding :.1rem 0;
}
.circle p span {
  display: inline-block;
  margin: 0px 5px;
  color: #333;
  font-size: 0.22rem;
  font-family: '微软雅黑'
}
.ratevalue-warpper{
  display: flex;
  justify-content: space-around;
}
.ratevalue-value-second img{
  height:.35rem;
  width: 1px;
  margin-top .1rem
}
.ratevalue-value p{
  text-align : center;
  color : #999;
}
.ratevalue-value span{
  font-size : 0.20rem;
}
.tiem-iconfont{
  float: right;
  padding-left: .12rem;
  color : #999;
}
.circleHeight {
  margin-top: 0.1rem;
  padding: 0px 15px 15px 15px;
  background: #fff;
}

.circleTitle {
  font-size: 0.18rem;
  font-weight: 600;
  // height: 0.45rem;
  line-height: 0.45rem;
}
.circleTitle .nameTitle {
  line-height: normal;
  margin-top .08rem
}
.circleTitle div:last-child {
  text-align: right;
}

.circleFooter {
  font-size: 0.12rem;
  color: #BDBDBD;
}

.buttonChange {
  font-size: 0;
  text-align: right;
}

.buttonChange button {
  height: 0.26rem;
  line-height: 0.26rem;
  border: none;
  margin: 0;
  font-size: 0;
  font-size: 0.14rem;
  padding: 0 15px;
  color: #39f;
  background: none;
  border: 1px solid #39f;
  border-radius: 0.02rem;
}

.timeButton button {
  border: 1px solid #F2F2F2;
  color: #999;
}

.buttonChange .choose {
  background: #3399FF;
  border: 1px solid #3399FF;
  color: #fff;
  border-radius: 0.02rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/EntDetailCard.vue